module.exports = __webpack_public_path__ + "static/media/23.2f7bd61b.jpg";